import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadAspectRatioCardImage } from '../Carousel/CarouselCard';
import { TallCarouselCard, AspectRatioCardTitle, AspectRatioCardText } from '../Carousel/CarouselCard';

import './PropertyTypeCard.less';

const PropertyTypeCard = ({
  clickUrl,
  title,
  subtitle,
  imageUri,
  onClick,
  loadImage
}) => (
  <TallCarouselCard
    clickUrl={clickUrl}
    className="PropertyTypeCard"
    onClick={onClick}
  >
    <LazyLoadAspectRatioCardImage
      data-slot="figure"
      imageUri={imageUri}
      loadImage={loadImage}
    />
    <AspectRatioCardTitle data-slot="caption" title={title} />
    <AspectRatioCardText data-slot="content" text={subtitle} />
  </TallCarouselCard>
);

PropertyTypeCard.propTypes = {
  clickUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  imageUri: PropTypes.string.isRequired
};

export default React.memo(PropertyTypeCard);
